import { useQuery } from '@tanstack/react-query';
import { DictResponse } from '@spilca/order_ts/v1/order/enum_pb';
import { QUERY_KEYS } from '@monorepo/helpers';
import { useI18n } from '@monorepo/i18n';
import {
  TGroupingKey,
  translateNormalizedDictionary
} from '@monorepo/dictionary';
import { REQUEST_TYPES, useGetRequest } from '@monorepo/requests';

type TProps = {
  grouping: TGroupingKey;
  active: string | null;
  filter: object | undefined;
};

const useGetTypes = ({ grouping = 'id', filter, active }: TProps) => {
  const { t } = useI18n();
  const getTypes = useGetRequest(REQUEST_TYPES.GET_TYPES_DEALS_REQUEST);

  return useQuery({
    queryKey: [QUERY_KEYS.LIST_DEALS_TYPES, filter],
    queryFn: (d): Promise<DictResponse.AsObject> => getTypes({ ...d, active }),
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 10*60*1000,
    gcTime: 2 * 60 * 1000,
    placeholderData: (previousData) => previousData,
    select: translateNormalizedDictionary(
      ({ name }) => t(`resource.${name}`),
      grouping
    )
  });
};

export default useGetTypes;
